(function () {
	'use strict';

	const modules = [];

	angular.module('DcProjectSubscriptionModule', modules);
})();
